import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import toast from "react-hot-toast";
import { searchAgents } from "./agentAPI";
import { IAgent } from "definitions/app/agent";

export interface AgentState {
    agents: IAgent[];
    status: "idle" | "loading" | "succeeded" | "failed";
}

const initialState: AgentState = {
    agents: [],
    status: "idle",
};
export const fetchAgentsAsync = createAsyncThunk(
    "agents/fetch",
    async (_, thunkAPI) => {
        const res = await searchAgents();
        //@ts-ignore
        return res.data.agents;
    }
);

export const agentSlice = createSlice({
    name: "agents",
    initialState,
    reducers: {
        resetStatus: (state) => {
            state.status = "idle";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAgentsAsync.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchAgentsAsync.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.agents = action.payload;
                toast.success("Agents Loaded", { id: fetchAgentsAsync.name });
            })
            .addCase(fetchAgentsAsync.rejected, (state, action) => {
                state.status = "failed";
                toast.error((action.payload as string) ?? "Error loading agents", {
                    id: fetchAgentsAsync.name,
                });
            });
    },
});

export const { resetStatus } = agentSlice.actions;
export const selectAgents = (state: RootState) => state.agents;
export default agentSlice.reducer;
